import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { enqueueBulkRequestRpc } from '../../../../../__generated__/chirp/com/hubspot/custom/enrichment/rpc/client/SmartPropertiesBulkService';
import { getRecordCount } from '../../../utils';
import { performCRMSearchWithEmptyProperties } from '../../../CRMSearchProvider/client';
import { FILL_EMPTY_ONLY_OPTION_VAL } from '../../../../constants';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export function runSmartFill(context) {
  const isFillEmptyOnly = context.fillOption === FILL_EMPTY_ONLY_OPTION_VAL;
  const baseRequest = {
    objectTypeId: context.objectTypeId,
    propertyNames: context.selectedProperties,
    estimatedObjectCount: getRecordCount({
      selectionMethod: context.selectionMethod,
      selectionCrmSearchQuery: context.selectionCrmSearchQuery,
      selectionIds: context.selectionIds
    }),
    fillEmptyValuesOnly: isFillEmptyOnly
  };
  let request;
  if (context.selectionMethod === 'BY_IDS') {
    request = Object.assign({}, baseRequest, {
      selectedObjectIds: context.selectionIds.map(Number)
    });
  } else {
    request = Object.assign({}, baseRequest, {
      selectedObjectIds: [],
      searchRequest: Object.assign({}, context.selectionCrmSearchQuery, {
        objectTypeId: context.objectTypeId
      })
    });
  }
  return rpcClient.call(enqueueBulkRequestRpc, {
    request
  });
}
export async function getEmptyPropertiesCount(context) {
  const {
    selectionCrmSearchQuery,
    selectedProperties
  } = context;
  if (!selectionCrmSearchQuery) {
    return 0;
  }
  const result = await performCRMSearchWithEmptyProperties({
    query: selectionCrmSearchQuery
  }, selectedProperties);
  return result.total;
}
export async function getEmptyPropertiesCountByIds(context) {
  const {
    selectionIds,
    selectedProperties,
    objectTypeId
  } = context;
  if (!selectionIds.length || !selectedProperties.length) {
    return 0;
  }
  const queryByIds = {
    objectTypeId: objectTypeId,
    count: selectionIds.length,
    filterGroups: [{
      filters: [{
        operator: 'IN',
        property: 'hs_object_id',
        values: selectionIds
      }]
    }]
  };
  const result = await performCRMSearchWithEmptyProperties({
    query: queryByIds
  }, selectedProperties);
  return result.total;
}